// Do not edit directly
// Generated on Mon, 19 Jun 2023 07:17:02 GMT

export const Laptop = 1440;
export const LaptopSm = 1280;
export const Tablet = 1024;
export const Mobile = 560;
export const MobileSm = 420;

export const Breakpoints = {
  Laptop,
  LaptopSm,
  Tablet,
  Mobile,
  MobileSm,
};
